import styled, { css } from "styled-components"
import { transparentize } from "polished"
import breakpoint from "styled-components-breakpoint"
import { TextField } from "../forms"

export const Container = styled.div`
  overflow: auto;
  overflow-y: hidden;
  max-width: 100%;
  overflow-x: auto;

  ${({ gridArea }) =>
    gridArea !== undefined &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}
`

export const Table = styled.table`
  background-color: white;
  width: 100%;
  border-radius: 1rem;
  border-collapse: collapse;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      border-radius: 0;
    `}
`

export const Th = styled.th`
  text-align: left;
  color: white;
  padding: 0.75rem 1rem;
  white-space: nowrap;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      color: ${({ theme }) => theme.colors.content.text};
      font-weight: 400;
      border-top: 1px solid #ececec;
      border-bottom: 1px solid #ececec;
      padding: 1.3rem 1rem;
      background-color: #f7f7f7;
      border-radius: 0 !important;
      height: 40px;
    `}
`

export const ThWrap = styled.th`
  text-align: left;
  color: white;
  padding: 0.75rem 1rem;
  white-space: normal;
`

export const Tr = styled.tr``

export const Td = styled.td`
  text-align: left;
  padding: 0.75rem 1rem;
  color: ${({ theme }) => theme.colors.content.text};

  ${({ centered }) =>
    !!centered &&
    css`
      text-align: center;
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      border-bottom: 1px solid #ececec;
      padding: 1.3rem 1rem;
      height: 40px;
      color: ${({ theme }) => theme.colors.content.text} !important;
    `}

  ${({ type }) =>
    type === "date" &&
    css`
      color: ${({ theme }) => theme.colors.content.text};
    `}
`

export const Thead = styled.thead`
  background-color: ${({ theme }) => theme.colors.primary};

  ${Tr}:first-child {
    ${Th}:first-child {
      border-top-left-radius: 1rem;
    }

    ${Th}:last-child {
      border-top-right-radius: 1rem;
    }
  }

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      background-color: transparent;
    `}
`

export const Tbody = styled.tbody`
  ${Tr}:nth-child(odd) {
    background-color: #fafafa;
  }

  ${Tr}:nth-child(even) {
    background-color: #f1f1f1;
  }

  ${Tr}:last-child {
    ${Td}:first-child {
      border-bottom-left-radius: 1rem;
    }

    ${Td}:last-child {
      border-bottom-right-radius: 1rem;
    }
  }

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      ${Tr}:nth-child(odd) {
        background-color: transparent !important;
      }

      ${Tr}:nth-child(even) {
        background-color: transparent !important;
      }
    `}
`

export const ActionsContainer = styled.div`
  white-space: nowrap;

  > * {
    width: 100%;
  }

  > :not(:last-child) {
    margin-bottom: 0.25rem;
  }

  ${breakpoint("tablet")`
    > * {
      width: unset;
    }

    > :not(:last-child) {
      margin: 0;
      margin-right: 0.25rem;
    }
  `}
`

export const SearchBox = styled(TextField)`
  font-size: 0.75rem;
  padding: 0.5rem 1rem;
  background-color: #f4f4f4;
  border: 1px solid #d8d8d8;
  color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
  width: unset;
  font-weight: bold;

  &::placeholder {
    color: ${({ theme }) => transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary)};
  }
`

export const MyInterviewsToggle = styled.label`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.6rem;
  margin: 15px 0 15px 3px;
  cursor: pointer;
`

export const MyInterviewsToggleText = styled.span`
  font-weight: bold;
`
